/**
 * Utility function used for adding params to IM360 API URLs only
 */
export const parametrizeURL = (url: string, params: Record<string, string>, process = encodeURIComponent) =>
    Object.keys(params).reduce((result, name) => result.replace(`{${name}}`, process(params[name])), url);
